import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';

class DLink extends React.Component<any> {
  render() {
    const { to, ...rest } = this.props;

    if (to === null) {
      return <a {...rest} />;
    }

    if (to.startsWith('/')) {
      return <Link to={to} {...rest} />;
    }

    return <a href={to} {...rest} />;
  }
}

const query = graphql`
  query {
    wordpressSiteMetadata {
      url
    }
  }
`;

export const DynamicLink = ({ to, ...rest }) => (
  <StaticQuery
    query={query}
    render={data => (
      <DLink
        to={to ? to.replace(data.wordpressSiteMetadata.url, '') : null}
        {...rest}
      />
    )}
  />
);
